// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */

.jp-WindowedPanel-outer {
  height: 100%;
  position: relative;
  overflow: auto;
}

.jp-WindowedPanel-inner {
  position: relative;
}

.jp-WindowedPanel-viewport {
  position: absolute;
  left: 0;
  right: 0;
  overflow: visible;
}

.jp-WindowedPanel-scrollbar {
  display: none;
  position: relative;
}

.jp-WindowedPanel.jp-mod-virtual-scrollbar > .jp-WindowedPanel-scrollbar {
  background-color: inherit;
  border-left: 1px solid var(--jp-layout-color3);
  display: block;
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
  top: 0;
  bottom: 0;
  right: 0;
  min-width: 35px;
  z-index: 1;
}

.jp-WindowedPanel-scrollbar-content {
  background-color: transparent;
  list-style-type: none;
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 3;
}

.jp-WindowedPanel-scrollbar-content > .jp-WindowedPanel-scrollbar-item {
  border-bottom: 1px solid var(--jp-layout-color3);
  background-color: rgb(from var(--jp-layout-color1) r g b / 50%);
  padding: 2px;
  text-align: left;
  margin: 0 2px;
}

.jp-WindowedPanel-scrollbar-content > .jp-WindowedPanel-scrollbar-item:hover {
  cursor: pointer;
  background-color: var(--jp-layout-color3);
}

.jp-WindowedPanel-scrollbar-viewportIndicator {
  position: absolute;
  background: var(--jp-layout-color2);
  border: 1px solid var(--jp-layout-color4);
  width: 100%;
  z-index: 2;
  border-radius: 2px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/ui-components/style/windowedlist.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,+DAA+D;EAC/D,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":["/*\n * Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n\n.jp-WindowedPanel-outer {\n  height: 100%;\n  position: relative;\n  overflow: auto;\n}\n\n.jp-WindowedPanel-inner {\n  position: relative;\n}\n\n.jp-WindowedPanel-viewport {\n  position: absolute;\n  left: 0;\n  right: 0;\n  overflow: visible;\n}\n\n.jp-WindowedPanel-scrollbar {\n  display: none;\n  position: relative;\n}\n\n.jp-WindowedPanel.jp-mod-virtual-scrollbar > .jp-WindowedPanel-scrollbar {\n  background-color: inherit;\n  border-left: 1px solid var(--jp-layout-color3);\n  display: block;\n  position: fixed;\n  overflow-y: auto;\n  overflow-x: hidden;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  min-width: 35px;\n  z-index: 1;\n}\n\n.jp-WindowedPanel-scrollbar-content {\n  background-color: transparent;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  z-index: 3;\n}\n\n.jp-WindowedPanel-scrollbar-content > .jp-WindowedPanel-scrollbar-item {\n  border-bottom: 1px solid var(--jp-layout-color3);\n  background-color: rgb(from var(--jp-layout-color1) r g b / 50%);\n  padding: 2px;\n  text-align: left;\n  margin: 0 2px;\n}\n\n.jp-WindowedPanel-scrollbar-content > .jp-WindowedPanel-scrollbar-item:hover {\n  cursor: pointer;\n  background-color: var(--jp-layout-color3);\n}\n\n.jp-WindowedPanel-scrollbar-viewportIndicator {\n  position: absolute;\n  background: var(--jp-layout-color2);\n  border: 1px solid var(--jp-layout-color4);\n  width: 100%;\n  z-index: 2;\n  border-radius: 2px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
